import deleteDoc from '../../utils/db/deleteDoc'

const deleteCampaignLink = async (id) => {
  const docId = typeof id === 'string' ? id.trim() : ''

  if (!docId) {
    return {
      ok: false,
      message: 'Не вказано id посилання',
    }
  }

  try {
    await deleteDoc({ path: 'campaign_links', docId })

    return {
      ok: true,
    }
  } catch (error) {
    console.error('[deleteCampaignLink] failed:', error)

    const code = typeof error?.code === 'string' ? error.code : ''
    const message =
      code === 'permission-denied'
        ? 'Немає доступу до видалення цього посилання'
        : code === 'not-found'
          ? 'Посилання не знайдено'
          : error?.message || 'Не вдалося видалити посилання'

    return {
      ok: false,
      message,
    }
  }
}

export default deleteCampaignLink
